import ApiService from '@/services/ApiService';

const BASE_URI = '/customer';

export default {
  list() {
    return ApiService().get(`${BASE_URI}/list`);
  },
  
  crawl() {
    return ApiService().post(`${BASE_URI}/crawl`);
  },

  add(customer) {
    const uri = `${BASE_URI}/add`;
    return ApiService().post(uri, customer, true);
  },

  update(customer) {
    const uri = `${BASE_URI}/update/${customer.id}`;
    return ApiService().put(uri, customer, true);
  },

  delete(customerID) {
    return ApiService().delete(`${BASE_URI}/delete/${customerID}`);
  },

};
